// Client-side reads of a JWT's `exp`. The signature is never checked here: the server
// is the only authority on validity. This exists so the app can act before a call fails.

const decodeSegment = (segment) => {
  const padded = segment.replace(/-/g, '+').replace(/_/g, '/');
  const json = atob(padded.padEnd(Math.ceil(padded.length / 4) * 4, '='));
  return JSON.parse(json);
};

// Milliseconds since epoch, or null when the token is absent or unreadable.
export const jwtExpiresAt = (token) => {
  if (!token) return null;
  const segment = token.split('.')[1];
  if (!segment) return null;
  try {
    const { exp } = decodeSegment(segment);
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
};

// An unreadable token counts as expired: it can never authenticate a request, so
// treating it as live would strand the user in the dead-app state this whole flow fixes.
export const isJwtExpired = (token, skewMs = 0) => {
  const expiresAt = jwtExpiresAt(token);
  if (expiresAt === null) return true;
  return Date.now() + skewMs >= expiresAt;
};
